import { type MergeResponse } from 'api/hooks/useMerge/types'

export const useMergeResponses: MergeResponse = {
  commitId: 'a94a8fe5ccb19ba61c4c0873d391e987982fbbd3'
}
